export { default } from './product-detail/index';
